
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/wifi-networks",
      function () {
        return require("private-next-pages/android/wifi-networks/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/wifi-networks"])
      });
    }
  